export var EntitlementState;
(function (EntitlementState) {
    EntitlementState[EntitlementState["active"] = 0] = "active";
    EntitlementState[EntitlementState["inactive"] = 1] = "inactive";
    EntitlementState[EntitlementState["canceled"] = 2] = "canceled";
    EntitlementState[EntitlementState["inIssue"] = 3] = "inIssue";
    EntitlementState[EntitlementState["unknown"] = 4] = "unknown";
    EntitlementState[EntitlementState["none"] = 5] = "none";
})(EntitlementState || (EntitlementState = {}));
